// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"category_wrapper__3MDlV","title":"category_title__CEWXc","icon":"category_icon__30gqe"};